// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeNotificationSettingsClearPoolOverrideBody = {
  poolId: string;
  alertKind?:
    | "contestStarted"
    | "contestFinished"
    | "seasonStarted"
    | "poolSettingsChanged"
    | "pickReminder"
    | "roundGraded"
    | "eliminated"
    | "revived"
    | "spreadMoved"
    | "customAwardChanged"
    | "squaresLockUnlock"
    | "squaresGridPublished"
    | "squaresWinnerSet"
    | "squaresWinnerUpdated"
    | "squaresSquareAssigned"
    | "squaresScoreCorrection"
    | "stripCardLockUnlock"
    | "memberWaitingApproval"
    | "roundLocked"
    | "contestCorrected"
    | "stripCardStripAdded"
    | "stripCardFilled"
    | "stripCardSpotAssigned"
    | "stripCardSpotUnassigned"
    | "stripCardWinner"
    | "stripCardGameCanceled";
};

export type typeNotificationSettingsClearPoolOverrideOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { poolId: string; followsGlobal: boolean };
};

export type typeNotificationSettingsClearPoolOverrideOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsClearPoolOverrideOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsClearPoolOverrideOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaNotificationSettingsClearPoolOverrideBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    alertKind: {
      type: "string",
      enum: [
        "contestStarted",
        "contestFinished",
        "seasonStarted",
        "poolSettingsChanged",
        "pickReminder",
        "roundGraded",
        "eliminated",
        "revived",
        "spreadMoved",
        "customAwardChanged",
        "squaresLockUnlock",
        "squaresGridPublished",
        "squaresWinnerSet",
        "squaresWinnerUpdated",
        "squaresSquareAssigned",
        "squaresScoreCorrection",
        "stripCardLockUnlock",
        "memberWaitingApproval",
        "roundLocked",
        "contestCorrected",
        "stripCardStripAdded",
        "stripCardFilled",
        "stripCardSpotAssigned",
        "stripCardSpotUnassigned",
        "stripCardWinner",
        "stripCardGameCanceled",
      ],
    },
  },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createNotificationSettingsClearPoolOverride(
  options: SdkOptions,
) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(
      schemaNotificationSettingsClearPoolOverrideBody,
    );
  }

  return async function postNotificationSettingsClearPoolOverride(
    payload: typeNotificationSettingsClearPoolOverrideBody,
  ): Promise<
    | typeNotificationSettingsClearPoolOverrideOutput200
    | typeNotificationSettingsClearPoolOverrideOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postNotificationSettingsClearPoolOverride" failed before calling the network. #4f52b32cb103`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#4f52b32cb103" },
        },
        data: null,
      } as typeNotificationSettingsClearPoolOverrideOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/notification-settings/clear-pool-override`,
      httpMethod: "POST",
      options,
    })) as
      | typeNotificationSettingsClearPoolOverrideOutput200
      | typeNotificationSettingsClearPoolOverrideOutput400;
  };
}
